// extracted by mini-css-extract-plugin
module.exports = {"status":"VoiceControlPinDialog_status__2GjOD"};